import worldList from './world'
import { factions, jobs } from './job'
import { kebabCase } from 'change-case'
export interface rankingOptionI {
  id?: number | string // for db query
  key: string // for route
  name: string
  kind?: string
  filter?: string // filter condition for filter options
  children?: rankingOptionI[]
  dependancies?: string[]
  default?: boolean
}

export const rankingRegions: rankingOptionI[] = [
  { id: 'na', key: 'north-america', name: 'North America', default: true },
  { id: 'eu', key: 'europe', name: 'Europe' },
]

export const rankingTypes: rankingOptionI[] = [
  { key: 'overall', name: 'Overall' },
  { key: 'achievement', name: 'Achievement' },
  { key: 'fame', name: 'Fame' },
  { key: 'job', name: 'Job' },
  { key: 'legion', name: 'legion' },
  { key: 'world', name: 'World' },
]

export const rankingFilters: rankingOptionI[] = [
  { key: 'weekly', name: 'Weekly', dependancies: ['overall', 'fame'] },
  { key: 'monthly', name: 'Monthly', dependancies: ['overall', 'fame'] },
  { key: 'legendary', name: 'Legendary', dependancies: ['overall', 'fame'] },
  {
    key: 'classic-rankings',
    name: 'Classic Rankings',
    dependancies: ['overall'],
    children: [
      { key: 'classic', name: 'Lv. 200', kind: 'classic-rankings' },
      { key: 'classic250', name: 'Lv. 250', kind: 'classic-rankings' },
      { key: 'classic275', name: 'Lv. 275', kind: 'classic-rankings' },
      { key: 'jett', name: 'Jett', kind: 'classic-rankings' },
      { key: 'beasttamer', name: 'Beast Tamer', kind: 'classic-rankings' },
    ],
  },
  {
    key: 'faction',
    name: 'Faction',
    dependancies: ['job'],
    children: factions.map((x) => ({ ...x, kind: 'faction' })),
  },
  {
    key: 'job',
    name: 'Job',
    dependancies: ['job'],
    children: jobs
      .map((o) => ({
        ...o,
        key: kebabCase(o.name),
        kind: 'job',
        filter: factions.find((x) => x.jobsAvailableIn.includes(o.id))?.key,
      }))
      .filter((o) => o.filter),
  }, // dynamic children contents
  {
    key: 'world',
    name: 'World',
    dependancies: ['legion', 'world'],
    children: worldList.map((x) => ({ ...x, kind: 'world' })),
  },
]

const _worldTypes = [
  { id: 1, name: 'Heroic' },
  { id: 2, name: 'Interactive' },
  { id: 0, name: 'Both' },
]
export const worldTypes: rankingOptionI[] = _worldTypes.map((x) => ({ ...x, key: kebabCase(x.name) }))

interface tableHeadersOptionsI {
  [key: string]: { title: string; width?: string }[]
}

export const tableHeadersOptions: tableHeadersOptionsI = {
  default: [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Level/Move' },
  ],
  'overall/weekly': [
    { title: 'Rank', width: '12%' },
    { title: 'Character' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Exp Gained' },
  ],
  'overall/monthly': [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Exp Gained' },
  ],
  achievement: [
    { title: 'Tier' },
    { title: 'Rank', width: '12%' },
    { title: 'Character' },
    { title: 'Character Name' },
    { title: 'Job' },
    { title: 'Score' },
  ],
  'fame/weekly': [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Fame Gained' },
  ],
  'fame/monthly': [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Fame Gained' },
  ],
  'fame/legendary': [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Total Fame' },
  ],
  legion: [
    { title: 'Rank', width: '12%' },
    { title: 'Character', width: '15%' },
    { title: 'Character Name' },
    { title: 'Legion Level' },
    { title: 'World', width: '8%' },
    { title: 'Job', width: '8%' },
    { title: 'Raid Power' },
  ],
}

export const tableHeadersForMobile: tableHeadersOptionsI = {
  default: [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Level/Move' },
  ],
  'overall/weekly': [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Exp Gained' },
  ],
  'overall/monthly': [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Exp Gained' },
  ],
  achievement: [
    { title: 'Tier' },
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'Score' },
  ],
  'fame/weekly': [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Fame Gained' },
  ],
  'fame/monthly': [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Fame Gained' },
  ],
  'fame/legendary': [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Total Fame' },
  ],
  legion: [
    { title: 'Rank', width: '14%' },
    { title: 'Character', width: '18%' },
    { title: 'Name/Job', width: '25%' },
    { title: 'World', width: '10%' },
    { title: 'Legion Level' },
    // { title: 'Raid Power' },
  ],
}
